import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getDraw, saveDraw} from "../services/api";

export function EditDraw() {
    const { drawId } = useParams()
    const [draw, setDraw] = useState({})
    const navigate = useNavigate()

    useEffect(() => {
        const apiDraw =  getDraw(drawId)
            .then(apiDraw => {
                setDraw(apiDraw)
            })
            .catch(ex => {
                console.log("Error getting draw: ", ex)
            })
    }, []);
    
    const setChosen = (input) => {
        setDraw({
            ...draw,
            chosen: !draw.chosen
        })
    }
    
    const setRunTime = (event) => {
        setDraw({
            ...draw,
            runTime: event.target.value
        })
    }
    
    const setResult = (event) => {
        setDraw({
            ...draw,
            result: event.target.value
        })
    }
    
    const submit = async (event) => {
        event.preventDefault()
        try {
            await saveDraw(draw);
            navigate(`/decisions/${draw.decisionId}`)
        } catch (ex) {
            console.log("Error Saving Draw: ", ex)
        }
    }
    
    return (
        <>
            <form onSubmit={submit}>
                <div className="form-group mb-3">
                    <label>Chosen</label>
                    <div className="form-check">
                        <input type="checkbox" name="chosen" checked={draw.chosen} onClick={setChosen}/>
                    </div>
                </div>
                <div className="form-group mb-3">
                    <label>Result</label>
                    <input type="text" className="form-control" value={draw.result} onChange={setResult}/>
                </div>
                <div className="form-group mb-3">
                    <label>Run Time</label>
                    <input type="text" className="form-control" value={draw.runTime} onChange={setRunTime}/>
                </div>
                <div className="form-group">
                    <button className="btn btn-primary">Submit</button>
                </div>
            </form>
        </>
    )

}